// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/OrderTotalDisplaySharedStyles";
import { orderApprovalDetailsTotalStyles } from "@steiner/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsTotal";
import { css } from "styled-components";

orderApprovalDetailsTotalStyles.container = {
    css: css`
        ${({ isOnlyPrint }: { isOnlyPrint?: boolean }) => isOnlyPrint && "display: none;"}

        @media print {
            margin: 20px 0;
            justify-content: flex-end;
            display: ${({ isOnlyPrint }: { isOnlyPrint?: boolean }) => (isOnlyPrint ? "flex" : "none")};
        }
    `,
};

orderApprovalDetailsTotalStyles.fullWidthGridItem = {
    ...orderTotalDisplaySharedStyles.fullWidthGridItem,
};

orderApprovalDetailsTotalStyles.actionButtonsWrapper = {
    ...orderTotalDisplaySharedStyles.fullWidthGridItem,
    css: css`
        column-gap: 20px;
    `,
};
